import { ComponentIds, ViewerObjectComponent } from '@inter-ikea-core/core';
import { PlannerEcsMultiSystem } from '@inter-ikea-storageone/range';
/**
 * This system will add an invisible view object between the LADMAKARE section panels
 * so that the user can click anywher betweeen them and still select the section
 */
export class InteractableSectionSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'InteractableSectionSystem', [
            ComponentIds.IN_SCENE_COMPONENT_ID,
            ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID
        ]);
        this.placementService = coreApi.placementService;
    }
    onAdd(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID) {
            const isSection = entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID);
            if (isSection) {
                this.addViewerToSectionBox(entity);
            }
        }
        else {
            const parent = entity.getComponent(ComponentIds.CHILD_COMPONENT_ID)?.parent;
            const isSection = parent && parent.hasComponent(ComponentIds.FRAME_COMPONENT_ID);
            if (isSection) {
                this.addViewerToSectionBox(parent);
            }
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID) {
            if (entity.hasComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)) {
                const entityAfterLoadingSnapshot = oldComponent
                    .entity;
                const stateBeforeLoadingSnapshot = oldComponent
                    .entityStateBeforeLoadingSnapshot;
                if (!entityAfterLoadingSnapshot && stateBeforeLoadingSnapshot) {
                    const viewerObjectComponent = stateBeforeLoadingSnapshot.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
                    if (!viewerObjectComponent)
                        return;
                    viewerObjectComponent.viewerObject.deleteObject();
                }
                else if (entityAfterLoadingSnapshot && !stateBeforeLoadingSnapshot) {
                    const parentEntityComponent = entity.getComponent(ComponentIds.CHILD_COMPONENT_ID);
                    if (!parentEntityComponent)
                        return;
                    const parentEntity = parentEntityComponent.parent;
                    const isSection = parentEntity.hasComponent(ComponentIds.FRAME_COMPONENT_ID);
                    if (!entity.hasComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID) && isSection) {
                        this.addViewerToSectionBox(parentEntity);
                    }
                }
            }
        }
    }
    addViewerToSectionBox(entity) {
        const sectionBox = entity
            .getComponent(ComponentIds.PARENT_COMPONENT_ID)
            ?.children?.find(c => c.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey ===
            'section-box');
        if (sectionBox) {
            const hasViewer = sectionBox.hasComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
            if (hasViewer)
                return; // Stop if viewer already has been applied to the section box
            const size = sectionBox.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size.vector;
            if (!size)
                return;
            try {
                const model = this.coreApi.viewer.createBox(size.X, size.Y, size.Z, entity);
                model.registerInputEvents();
                model.setBaseColor(1, 1, 1);
                model.setTransparency(0.01);
                sectionBox.addComponent(new ViewerObjectComponent(model));
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error('Failed to create viewer object for section box', e);
            }
        }
    }
}
//# sourceMappingURL=InteractableSectionSystem.js.map